__turbopack_context__.v({
  "realtor_card": "styles-module-scss-module__L91qKa__realtor_card",
  "two_agents": "styles-module-scss-module__L91qKa__two_agents",
});
